import { ReactNode, createContext, useContext, useEffect, useState } from "react";
import { activate, fetchAndActivate, getValue, remoteConfig } from ".";

type IContext = {
	config: any;
	readConfig: (key: string) => string[];
};

const RemoteConfigContext = createContext<any>({
	config: {},
	readConfig: undefined,
});

const RemoteConfigProvider = ({ defaults, children }: { defaults: any; children: ReactNode }) => {
	const [config, setConfig] = useState<any>();

	useEffect(() => {
		const fetchRemoteConfig = async () => {
			await fetchAndActivate(remoteConfig);

			// Get the value for the key 'welcome_message' from Remote Config

			const configArray = defaults.split(",");

			const resConfig: any = {};

			for (const config of configArray) {
				const keyConfig = Object.keys(resConfig);

				if (!keyConfig.includes(config)) {
					const value = getValue(remoteConfig, config).asString();

					resConfig[`${config}`] = value || "";
				}
			}

			setConfig(resConfig);
		};

		fetchRemoteConfig();
		activate(remoteConfig);
	}, [defaults]);

	const readConfig = (key: string): string[] => {
		if (!key) return [];

		if (config && config[key]) {
			return config[key]?.split(",");
		}

		return [];
	};

	return (
		<RemoteConfigContext.Provider
			value={{
				config,
				readConfig,
			}}
		>
			{children}
		</RemoteConfigContext.Provider>
	);
};

export const useRemoteConfig = () => {
	const context = useContext(RemoteConfigContext);
	return context;
};

export default RemoteConfigProvider;
